jQuery(function($) {

	$( document ).ready(function() {
    if($('#company_id').length) {
	    $('#company_id').select2();
    }

		var freelancerFields = "#submit-job-form .fieldset-how_many_freelancers, #submit-job-form .fieldset-project_lifecycle, #submit-job-form .fieldset-experienced_on_hiring, #submit-job-form .fieldset-payment_type, #submit-job-form .dependent-field-payment_type";

		var freelanceOptionText = "Freelance";


		if($('#submit-job-form').length) {
			//Adding Class for Freelance Fields
	    $(freelancerFields).addClass("freelancer-field");

			//Checking if freelance dropdown are selected on load
			$("select#job_type option:selected").each(function() {
				if($(this).text()==freelanceOptionText){
					$(freelancerFields).addClass("active");
					$(freelancerFields).find("input").attr("required", true);
				}
			});

			$('select#job_type').change(function () {
					var displayFreelance = false;

					$("select#job_type option:selected").each(function() {
						if($(this).text()==freelanceOptionText ){
							displayFreelance = true;
						}
					});

					if(displayFreelance && !$(freelancerFields).hasClass("active")){

						//console.log("activate");
						$(freelancerFields).addClass("active");
						$(freelancerFields).find("input").attr("required", true);

					} else if( !displayFreelance && $(freelancerFields).hasClass("active")) {

						//console.log("destroy");
						$(freelancerFields).removeClass("active");
						$(freelancerFields).find("input").attr("required", false);

					}
			});

    }
  });

});
